import { normalizePath } from "../../lib/pages";
import { DocsPage } from "./docs";
import {
  HomePage,
  ProductPage,
  UseCasesPage,
  IntegrationsPage,
  PricingPage,
  ChangelogPage,
  PrivacyPage,
  SupportPage,
  NotFoundPage,
} from "./pages";
import { Layout } from "./ui";
import { ChatGPTSetup } from "../product/chatgpt-setup";
export function MarketingApp({ path }: { path: string }) {
  const route = normalizePath(path);
  const page =
    route === "/connect/chatgpt" ? (
      <ChatGPTSetup />
    ) : route === "/" ? (
      <HomePage />
    ) : route === "/product" ? (
      <ProductPage />
    ) : route === "/use-cases" ? (
      <UseCasesPage />
    ) : route === "/integrations" ? (
      <IntegrationsPage />
    ) : route === "/pricing" ? (
      <PricingPage />
    ) : ["/docs", "/docs/workspace", "/docs/mcp", "/docs/api"].includes(
        route,
      ) ? (
      <DocsPage path={route} />
    ) : route === "/changelog" ? (
      <ChangelogPage />
    ) : route === "/support" ? (
      <SupportPage />
    ) : route === "/privacy" ? (
      <PrivacyPage />
    ) : (
      <NotFoundPage />
    );
  return <Layout path={route}>{page}</Layout>;
}
